import { useQueryParam } from '../../hooks/useQueryParam';
import { useSetPageMeta } from '../../hooks/useSetPageMeta';
import { Tabs } from '../../components/ui/tabs';
import { SystemSettingsTab } from './SystemSettingsTab';
import { SubscriptionPricingTab } from './SubscriptionPricingTab';
import { IndustriesTab } from './IndustriesTab';
import { NotificationSettingsTab } from './NotificationSettingsTab';

export function SettingsPage() {
	useSetPageMeta('Settings', [{ label: 'Settings' }]);
	const [tab, setTab] = useQueryParam('tab', 'system');

	return (
		<div className="mx-auto max-w-[var(--content-max)] px-4 pt-6 pb-20 sm:px-6 md:px-8 md:pt-8">
			{/* ── Header ── */}
			<div className="mb-6">
				<h1 className="mb-2 text-2xl font-medium leading-tight -tracking-[0.02em] text-text-1 sm:text-3xl">
					Settings
				</h1>
				<p className="text-base text-text-3">Manage platform preferences and options.</p>
			</div>

			{/* ── Tabs ── */}
			<div className="mb-6">
				<Tabs
					value={tab}
					onChange={setTab}
					items={[
						{ value: 'system', label: 'System settings' },
						{ value: 'subscription', label: 'Subscription pricing' },
						{ value: 'industries', label: 'Industries' },
						{ value: 'notifications', label: 'Notifications' },
					]}
				/>
			</div>

			{/* ── Tab content ── */}
			{tab === 'system' && <SystemSettingsTab />}
			{tab === 'subscription' && <SubscriptionPricingTab />}
			{tab === 'industries' && <IndustriesTab />}
			{tab === 'notifications' && <NotificationSettingsTab />}
		</div>
	);
}
